import React, { Component } from 'react';
import RecordLabels from './RecordLabels.js';
import YoutubeThumbnail from './YoutubeThumbnail.js';
import GenericSearcher from './GenericSearcher.js';
import DiscogsSearchResult from './DiscogsSearchResult.js';
import PulseLoader from 'react-spinners/PulseLoader'
import DiscogsThumbnail from './DiscogsThumbnail.js';
import LabelRelease from './LabelRelease.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {getYoutubeTitle} from './getYoutubeTitle.js';
import Discogs from 'discogs/Discogs.js';

class DiscogsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchTerms:'',
            showSearchResults: false,
            searchResults: [],
        };
        this.discogs = new Discogs();
    }

    onChangeSearch(text) {
        this.setState({
            searchTerms: text
        });
    }

    async onSearch() {
        let results = await this.discogs.searchRecords(
            this.state.searchTerms);

        this.setState({
            showSearchResults: true,
            searchResults: results});
    }

    render() {
        if (!this.props.show) {
            return (
                <div></div>
            );
        }

        return (
            <div>
              <GenericSearcher
                onChange={(v) => this.onChangeSearch(v)}
                onSearch={() => this.onSearch()}
                placeHolder="Type record name"
                searchTerms={this.state.searchTerms}>
              </GenericSearcher>
              <div className="search-results">
                {this.state.searchResults.map(
                    result =>
                        <DiscogsSearchResult
                              result={result}
                              onClick={() => this.selectRecord(result)}/>
                )}
              </div>
            </div>
        );
    }
}

export default DiscogsView;
